<div class="bcg p-4">
  <div class="row">
    <!-- <div class="col-lg-6 col-sm-6 col-md-6 pt-1">
            <p class="nav_link_cat_upload ms-1 "><span class="clickable" (click)="gotoDashboard()">Dashboard</span> >>
                Services
                >> {{displaybread}}</p>
        </div> -->

    <div class="col-lg-8 col-sm-6 col-md-6">
      <div class="d-flex justify-content-between custom-container">
        <nav class="custom-nav">
          <ol class="breadcrumb">
            <li
              class="breadcrumb-item"
              style="cursor: pointer"
              (click)="gotoDashboard()"
            >
              Dashboard
            </li>
            <!-- <li class="breadcrumb-item" style="cursor: pointer">Services</li> -->
            <li
              class="breadcrumb-item active"
              style="cursor: context-menu"
              aria-current="page"
            >
              {{ displaybread }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="col-lg-4 col-sm-3 col-md-3" style="margin-top: 3rem"></div>
    <div *ngIf="!isCatImport" class="col-lg-3 col-sm-3 col-md-3 overlay_1">
      <app-select-branch
        (OnBranchChangeData)="changeState($event)"
      ></app-select-branch>
    </div>
  </div>

  <div *ngIf="showUploadDocuments" class="card mt-3">
    <div class="card-body">
      <div class="row">
        <div *ngIf="!isCatImport" class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="card-title title_header_0">
            Contract Execution - {{ displaybread }}
          </h5>
          <p class="card-text text_p">
            Ensure your documents are signed and stamped with ease by following
            a few simple steps.
          </p>
        </div>
        <div *ngIf="isCatImport" class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="card-title title_header_0">{{ displaybread }}</h5>
          <p class="card-text text_p">
            Ensure your contracts are imported seamlessly by following a few
            simple steps.
          </p>
        </div>

        <div
          *ngIf="!isCatImport"
          class="col-lg-6 col-sm-3 col-md-3 text-right custom_button"
        >
          <p-button
            *ngIf="uploadId != 'E-Sign'"
            label="Article Code List"
            (click)="getArticleCode(articleList)"
            styleClass="p-button-sm-outline mx-2"
          ></p-button>

          <p-button
            label="Back"
            (click)="goBack()"
            styleClass="p-button-sm mx-2"
          ></p-button>
        </div>
        <div
          *ngIf="isCatImport"
          class="col-lg-6 col-sm-3 col-md-3 text-right custom_button"
        >
          <p-button
            label="Document's List"
            icon="pi pi-file"
            styleClass="p-button-sm mx-2 p-button-outlined"
            (click)="goToDocumentList()"
          >
          </p-button>
          <p-button
            label="Back"
            (click)="goBack()"
            styleClass="p-button-sm mx-2"
          ></p-button>
        </div>
      </div>
    </div>
  </div>
  <div class="card mt-3 card_style_bs_order_cat">
    <div class="card-body">
      <h5 class="card-title title_header_0">
        Complete Your Process in Just 2 Easy Steps
      </h5>

      <div class="d-flex">
        <ul class="row steps_style box_cat_upload">
          <li
            [ngClass]="[
              active_product ? 'box-item_active' : '',
              showUploadDocuments ? 'boxOutline' : 'box-item'
            ]"
            class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            (click)="
              showUploadDocuments ? goToCatExecutionScreen('uploadDocs') : null
            "
          >
            1. Upload documents
          </li>

          <li
            [ngClass]="[
              active_confirm ? 'box-item_active' : '',
              showConfirmation ? 'boxOutline' : 'box-item'
            ]"
            class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
          >
            2. Order confirmation
          </li>
        </ul>
        <div *ngIf="!showConfirmation">
          <a *ngIf="uploadId === 'E-Stamp'" class="text-right mt-2">
            <p-button
              label="Download Template"
              (click)="downloadSample('E-Stamp')"
              styleClass="p-button-sm-outline"
            >
              <i class="upload_icon_color bx bx-download bx-sm"></i>
            </p-button>
          </a>
          <a *ngIf="uploadId === 'E-Sign'" class="text-right mt-2">
            <p-button
              label="Download Template"
              (click)="downloadSample('E-Sign')"
              styleClass="p-button-sm-outline "
            >
              <i class="upload_icon_color bx bx-download bx-sm"></i>
            </p-button>
          </a>

          <div *ngIf="uploadId === 'Cat-Upload'" class="overlay">
            <p-splitButton
              class="p-splitbutton"
              label="Download Template"
              [model]="itemsCatUpload"
              styleClass="p-button-sm-outline mr-2 mb-2"
            ></p-splitButton>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Created useable components  so that we can use in estamp , esign and cat-upload Services     -->

  <div *ngIf="showUploadDocuments && !isCatImport">
    <upload-documents
      [uploadDocumentsData]="uploadDocumentsData"
      (uploadDocsChange)="onUploadDocsChange($event)"
    ></upload-documents>
  </div>

  <div *ngIf="showConfirmation">
    <app-order-confirmation-details
      #orderDetails
      [orderConfirmationData]="orderConfirmationData"
      (orderConfirmationChange)="onOrderConfirmationChange($event)"
    ></app-order-confirmation-details>
  </div>
  <div *ngIf="showUploadDocuments && isCatImport">
    <div class="card mt-3 card_style_bs_order_cat">
      <div class="card-body">
        <div class="row col-lg-4 col-sm-4 col-md-4 upload-component">
          <span class="form_field" style="display: block"
            >Upload the PDF documents <span class="color_red">*</span></span
          >
          <a
            style="font-size: 18px; color: #612e86; margin: 10px 0px"
            class="btn-link upload-btn"
          >
            <p-button
              style="cursor: pointer"
              label="Upload"
              (click)="openUploadDocPopup()"
              styleClass="p-button-sm-outline upload_button_label clickable"
              [disabled]="uploadFiles.length >= 10"
            >
              <i class="upload_icon_color bx bx-upload bx-sm"></i>
            </p-button>
          </a>
          <span
            class="p-error"
            style="font-size: 0.5rem"
            *ngIf="submitted && uploadFiles.length === 0"
            >Please upload the pdf documents only</span
          >
          <!-- <span class="p-error" style="font-size: 0.5rem;" *ngIf="chooseFile">Please Select documents
                        to Upload</span> -->
        </div>
      </div>
    </div>
    <div
      class="card mt-3 card_style_bs_order_cat"
      *ngIf="uploadFiles.length !== 0"
    >
      <div class="card-body">
        <form [formGroup]="bulkOrderDetailsForm">
          <div formArrayName="orders">
            <div
              class="row d-flex upload-components"
              *ngFor="let order of orders.controls; let i = index"
              [formGroupName]="i"
            >
              <div
                class="col-lg-3 col-sm-2 col-md-3 overlay_1 upload-component"
              >
                <span style="font-size: 0.9rem !important">{{ i + 1 }}.</span>
                <span
                  class="badge background_color_3 status_title_1"
                  style="
                    color: #151515;
                    font-size: 0.75rem;
                    margin-left: 0.5rem;
                    padding: 0.5rem;
                    cursor: default;
                  "
                  [pTooltip]="uploadFiles[i]?.name"
                  tooltipPosition="top"
                >
                  {{
                    uploadFiles[i]?.name.length > 30
                      ? uploadFiles[i]?.name.substring(0, 30) + "..."
                      : uploadFiles[i]?.name
                  }}
                </span>
              </div>
              <!-- Account Dropdown -->
              <div
                class="col-lg-2 col-sm-2 col-md-2 overlay_1 upload-component"
              >
                <span class="form_field"
                  >Account<span class="color_red" style="padding-left: 3px"
                    >*</span
                  ></span
                >
                <div class="custom-input">
                  <app-dropdown
                    [options]="accountUserData"
                    class="custom-dropdown"
                    placeholder="Select Account"
                    optionLabel="account_name"
                    optionValue="account_id"
                    [filter]="true"
                    filterBy="account_name"
                    formControlName="account_id"
                    (onChange)="onSelectedAccount($event, i)"
                    appendTo="body"
                  ></app-dropdown>
                </div>
              </div>

              <!-- Branch Field -->
              <div
                class="col-lg-2 col-sm-2 col-md-2 overlay_1 upload-component"
              >
                <span class="form_field"
                  >Branch<span class="color_red" style="padding-left: 3px"
                    >*</span
                  ></span
                >
                <div class="custom-input">
                  <app-dropdown
                    [options]="branchData[i] || []"
                    class="custom-dropdown"
                    placeholder="Select Branch"
                    optionLabel="name"
                    optionValue="id"
                    [filter]="true"
                    filterBy="name"
                    formControlName="branch_id"
                    (onChange)="handleBranchSelection($event, i)"
                    appendTo="body"
                  ></app-dropdown>
                </div>
              </div>

              <!-- Reference Number Field -->
              <div
                class="col-lg-2 col-sm-2 col-md-2 overlay_1 upload-component"
              >
                <span class="form_field">
                  {{
                    showHdfcFields
                      ? "File number (As per HDFC Bank Sanction letter)"
                      : "Reference
                                    Number"
                  }}
                  <span class="color_red">*</span></span
                >
                <div style="display: flex;">
                   <div class="custom-input">
                <input
                  type="text"
                  pInputText
                  placeholder="Allows alphabets, numbers, _ and -"
                  formControlName="referance_id"
                  [readOnly]="!enableRefIdField"
                  [ngClass]="enableRefIdField ? '' : 'grey_background'"
                  (paste)="onReferencePaste($event)"
                />

                <ng-container *ngIf="order.get('referance_id') as refId">
                  
                  <span
                    class="p-error"
                    style="font-size: 0.8rem; display: block; padding-top: 0.2rem;"
                    *ngIf="refId.hasError('maxlength') && refId.touched">
                    *Maximum 80 characters allowed
                  </span>

                  <span
                    class="p-error"
                    style="font-size: 0.8rem; display: block; padding-top: 0.2rem;"
                    *ngIf="refId.hasError('invalidChars') && refId.touched">
                    *Only alphabets, numbers, _ and - are allowed
                  </span>

                </ng-container>
              </div>
              <div style="display: flex; align-items: center;"
                class="overlay_1 upload-component"
              >
                <i
                  id="loader-{{ i }}"
                  class="pi pi-spin pi-spinner"
                  style="
                    font-size: 1.3rem;
                    margin-left: 20px;
                    display: none;
                  "
                ></i>
                <i
                  id="checkmark-{{ i }}"
                  class="pi pi-check"
                  style="
                    font-size: 1.3rem;
                    margin-left: 20px;
                    color: green;
                    display: none;
                  "
                ></i>
                <button
                  type="button"
                  class="btn-preview-eye ms-3"
                  (click)="previewUploadedFile(i)"
                  pTooltip="Preview Document"
                  tooltipPosition="top"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#612e86" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
                <i
                  class="pi pi-times ms-2"
                  style="
                    font-size: 1.3rem;
                    color: red;
                    cursor: pointer;
                  "
                  pTooltip="Delete"
                  tooltipPosition="top"
                  (click)="removeFileName(i)"
                ></i>
              </div>
              </div>
            </div>
          </div>
          </div>
          <p-button
            [style.float]="'right'"
            label="Place Order"
            (click)="placeOrder()"
            styleClass="p-button-sm-outline"
          >
          </p-button>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #articleList let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeModel()"
      aria-label="Close"
    ></button>
  </div>
  <app-article-code-list></app-article-code-list>
</ng-template>
<div
  #uploadDocModal
  class="modal fade"
  id="uploadDocModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 pb-2">
        <h5 class="title_five fw-semibold">
          Upload Document <span class="text-danger">*</span>
        </h5>
        <button
          #closeUploadPopupBtn
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          [hidden]="true"
        ></button>
        <button
          type="button"
          class="btn-close"
          (click)="cancelUpload()"
        ></button>
      </div>

      <div class="modal-body px-4 py-2">
        <!-- Drag and Drop Area -->
        <div
          class="upload-area"
          [class.drag-over]="isDragging"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          (click)="fileInput.click()"
        >
          <div class="upload-content">
            <div class="upload-icon mb-2">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-muted"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17,8 12,3 7,8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
            </div>
            <h6 class="upload-title mb-2">Drop your files here</h6>
            <p class="upload-subtitle mb-2">
              or
              <span
                class="text-primary cursor-pointer text-decoration-underline"
                >click to select file</span
              >
            </p>
            <div class="upload-info">
              <small class="text-muted"
                >Supported format: <b>PDF, up to 15 MB</b></small
              >
            </div>
          </div>
        </div>

        <!-- Selected Files Display -->
        <div class="selected-files mt-3" *ngIf="fileName">
          <div
            class="file-item d-flex align-items-center justify-content-between p-2 border rounded"
          >
            <div class="d-flex align-items-center">
              <svg
                width="20"
                height="20"
                class="text-green me-2"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"
                />
              </svg>
              <span class="file-name">{{ fileName }}</span>
            </div>
          </div>
        </div>

        <div>
          <span
            class="p-error"
            style="font-size: 0.65rem; margin-top: 10px"
            *ngIf="chooseFile && !fileSizeError"
            >Please select documents to upload</span
          >
          <span
            class="p-error"
            style="font-size: 0.65rem; margin-top: 10px"
            *ngIf="fileSizeError"
          >
            File size exceeds maximum limit of 15MB. Please upload a smaller
            file.
          </span>
        </div>

        <!-- Cloud Service Integration Icons -->

        <div class="d-flex justify-content-center gap-4 mt-4">
          <div class="cloud-service-icon" title="Google Drive" trackClick="click_google_drive" (click)="openGoogleDrive()">
              <img src="assets/img/g-drive.png" alt="Google Drive" width="48" height="40">
          </div>
          <div
            class="cloud-service-icon"
            title="Upload from Link"
            trackClick="click_upload_from_link"
            (click)="openLink()"
          >
            <img
              src="assets/img/link.png"
              alt="Upload from Link"
              width="48"
              height="40"
            />
          </div>
          <div *ngIf="dropboxEnabled"
            class="cloud-service-icon"
            title="dropbox"
            trackClick="click_dropbox"
            (click)="openDropbox()"
          >
            <img
              src="assets/img/dropbox.png"
              alt="dropbox"
              width="48"
              height="40"
            />
          </div>
          <div
            class="cloud-service-icon"
            title="One Drive"
            trackClick="click_onedrive"
            (click)="openOneDrive()"
          >
            <img
              src="assets/img/onedrive.png"
              alt="One Drive"
              width="48"
              height="40"
            />
          </div>
        </div>

        <!-- Hidden File Input -->
        <input
          [hidden]="true"
          type="file"
          id="upload_file"
          (change)="onFileChange($event)"
          accept=".pdf"
          multiple
          #fileInput
        />
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-0 pt-1">
        <button
          type="button"
          class="btn btn-outline-secondary me-2"
          (click)="cancelUpload()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="uploadSelFile()"
          [disabled]="!fileName"
        >
          Upload
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Google Drive upload file -->
<app-google-drive-modal
  [isVisible]="showGoogleDriveModal"
  (fileSelected)="onGoogleDriveFileSelected($event)"
  (modalClosed)="onGoogleDriveModalClosed()"
>
</app-google-drive-modal>
<!-- Link upload file modal -->
<app-upload-link
  [isVisible]="showLinkModal"
  (fileSelected)="onLinkFileSelected($event)"
  (modalClosed)="onLinkModalClosed()"
>
</app-upload-link>
<!-- Dropbox upload file modal -->
<app-dropbox-modal *ngIf="dropboxEnabled"
  [isVisible]="showDropboxModal"
  (fileSelected)="onDropboxFileSelected($event)"
  (modalClosed)="onDropboxModalClosed()"
>
</app-dropbox-modal>
<!-- OneDrive upload file modal -->
<app-onedrive-modal
  [isVisible]="showOneDriveModal"
  (fileSelected)="onOneDriveFileSelected($event)"
  (modalClosed)="onOneDriveModalClosed()"
>
</app-onedrive-modal>

<app-document-preview-modal
  [(isVisible)]="previewModalVisible"
  [file]="previewFile"
  [fileName]="previewFileName"
  [mode]="previewModalMode"
  [multiple]="false"
  (onUpload)="onPreviewUploadConfirmed($event)"
  (onCancel)="onPreviewUploadCancelled()"
  (onSave)="onPreviewFileSaved($event)"
>
</app-document-preview-modal>
